import axios from "axios"
import { headers } from "../headers"
import { baseUrl } from "../URL"


export const definirModeAffichage = async(values)=>{
    return axios.post(baseUrl("definirmodeaffichage"), values, headers );
}
